<template lang="pug">
  .modal(
    role="dialog"
    tabindex="-1" 
    style="display:block;" 
    aria-hidden="true"
    )
    .modal-dialog.modal-dialog-scrollable.modal-dialog-centered(
      role="document"
      )
      .modal-content
        .modal-header
          SectionTitle(
            :sectionText="sectionText"
            )
        .modal-body
          .popup-item.popup-item--wrapColumn
            span.popup-text 
              | 標題
            input.popup-input(
              placeholder="請輸入標題" 
              @input="checkActive" 
              v-model="params.title" 
              :maxlength="contentLimitTitle"
              )
            span.popup-alertText(
              v-if="alert.content.alertText" 
              style="bottom: -16px;")
                | 格式不符
            div(:class="alert.content.counter")
              span.popup-remainingCounter {{ params.title.length }}
              span.popup-limitCounter {{ contentLimitTitle }}
          .popup-item.popup-item--wrapColumn
            span.popup-text
              | 澄清內容
            textarea(
              :class="alert.content.textarea" 
              rows=8 
              placeholder="請輸入正確的澄清內容" 
              v-model="params.content"
              :maxlength="contentLimit"
              @input="checkActive"
              )
            .popup-alertText(v-if="alert.content.alertText") 
              | 已達字數上限
            div(:class="alert.content.counter")
              span.popup-remainingCounter {{ params.content.length }}
              span.popup-limitCounter {{ contentLimit }}
          .popup-item.popup-item--wrapColumn
            span.popup-text 發布機關
            Dropdown(
              :id="componentId"
              placeholder="請選擇" 
              :selectText='govName' 
              :infos="infos" 
              optionClass="popup-option" 
              innerTextClass="popup-option-innerText" 
              @selectDropdown="selectDropdown"
              )
          .popup-item.popup-item--wrapColumn
            span(:class="alert.web.text")
              | 網頁連結URL
            input(
              :class="alert.web.input" 
              placeholder="即時新聞澄清連結" 
              @input="checkActive" 
              v-model="params.url"
              )
            .popup-alertText(
              v-if="alert.web.alertText" 
              tyle="bottom: -16px;"
              ) 
              | 格式不符合
          .popup-item.popup-item--wrapColumn
            span.popup-text 上傳圖片
            ImageUploadArticleImage(
              @uploadImg="uploadImg"
              @setThumbTitle='updateThumbTitle'
              :govAnnounceImageUrl='params.thumbnailUrl'
              :defaultThumbCaption='params.thumbnailTitle'
              )
            ImageUploadArticleImage(
              @uploadImg="uploadImg2"
              @setThumbTitle='updateThumbTitle2'
              :govAnnounceImageUrl='params.thumbnailUrl2'
              :defaultThumbCaption='params.thumbnailTitle2'
              )
        
          .popup-item.popup-item--wrapColumn
            .popup-check(:class="{ 'popup-checkbox--disabled': isTWSE }")
              input.popup-checkbox(type="checkbox" @input="_toggleRSS" v-model="params.isRss" :disabled="isTWSE")
              .popup-checkboxToggle
              .popup-paragraphCheck
                | 新增RSS到LINE Today。
            .popup-rssInput
              input.popup-input.popup-inputRSS(
                placeholder="請輸入標題"
                v-model="temp.rssTitle"
                @input='checkActive'
                data-rssInput
                :disabled="!this.params.isRss"
                :maxlength="contentLimitTitle")
              div.popup-counter--relative(:class="alert.content.counter")
                span.popup-remainingCounter {{ temp.rssTitle.length }}
                span.popup-limitCounter {{ contentLimitTitle }}
            
        .modal-footer
          PopupButtonsOnBottom(
            :isActive="isActive" 
            :isScrollablePopup='true'
            :isSingleButton='false' 
            @send="send" 
            @cancel="closePopup"
            )
</template>

<script>
import SectionTitle from '@/components/modules/section_title/section_title.vue';
import Dropdown from '@/components/modules/dropdown.vue';
import PopupButtonsOnBottom from '@/components/popup/popup-buttons-on-bottom.vue';
import ImageUploadArticleImage from '@/components/modules/image_upload/image_upload_article_image.vue';
import VueRecaptcha from 'vue-recaptcha';
import { lockBody, unlockBody, checkPopupAlert } from '@/plugins/tool.js';
import { isValidURL } from '@/plugins/format_check.js';

const TWSE_GOV_OPTION_ID = 37;

export default {
  components: {
    SectionTitle,
    Dropdown,
    PopupButtonsOnBottom,
    VueRecaptcha,
    ImageUploadArticleImage
  },
  props: {
    sectionText: String,
    type: String,
    govAnnounceInfo: Object
  },
  data() {
    return {
      infos: [],
      isActive: false,
      isProcessing: false,
      govName: '',
      params: {
        title: '',
        content: '',
        govOptionId: '',
        url: '',
        thumbnail: '',
        thumbnailUrl: '',
        thumbnailTitle: '',
        thumbnail2: '',
        thumbnailUrl2: '',
        thumbnailTitle2: '',
        language: 'zhtw',
        isRss: false,
        rssTitle: ''
      },
      contentLimit: 1000,
      contentLimitTitle: 40,
      componentId: '',
      alert: {
        content: {
          textarea: 'popup-textarea',
          counter: 'popup-counter',
          alertText: false
        },
        thumbnailTitle: {
          textarea: 'popup-textarea',
          counter: 'popup-counter',
          alertText: false
        },
        web: {
          text: 'popup-text',
          input: 'popup-input',
          alertText: false
        }
      },
      hasSent: false,
      recaptchaResponse: '',
      agreement: false,
      temp: {
        rssTitle: ''
      }
    };
  },
  mounted() {
    lockBody();
  },
  created() {
    if (this.type == 'edit') {
      this.params.content = this.govAnnounceInfo.content;
      this.params.title = this.govAnnounceInfo.title;
      this.params.govOptionId = this.govAnnounceInfo.govOption.id;
      this.params.url = this.govAnnounceInfo.url;
      this.params.thumbnail = this.govAnnounceInfo.thumbnail;
      this.params.thumbnail2 = this.govAnnounceInfo.thumbnail2;
      this.params.thumbnailUrl = this.govAnnounceInfo.thumbnailUrl;
      this.params.thumbnailTitle = this.checkThumbnailCaption1;
      this.params.thumbnailUrl2 = this.govAnnounceInfo.thumbnailUrl2;
      this.params.thumbnailTitle2 = this.checkThumbnailCaption2;
      this.params.isRss = this.govAnnounceInfo.isRss;
      this.temp.rssTitle = this.govAnnounceInfo.rssTitle;
      this.componentId = this.type + '-' + this.govAnnounceInfo.id;
      this.govName = this.govAnnounceInfo.govOption.name;
    } else this.componentId = this.type;
    this.getInfo();
  },
  computed: {
    checkThumbnailCaption1 () {
      let thumbnailCaption
      if (this.govAnnounceInfo.thumbnailTitle === null) {
        thumbnailCaption = ''
      } else {
        thumbnailCaption = this.govAnnounceInfo.thumbnailTitle
      }
      return thumbnailCaption
    },
    checkThumbnailCaption2 () {
      let thumbnailCaption
      if (this.govAnnounceInfo.thumbnailTitle2 === null) {
        thumbnailCaption = ''
      } else {
        thumbnailCaption = this.govAnnounceInfo.thumbnailTitle2
      }
      return thumbnailCaption
    },
    isTWSE () {
      return this.params.govOptionId === TWSE_GOV_OPTION_ID;
    }
  },
  methods: {
    async getInfo() {
      let route =
        this.$store.state.URLs.apiPartner +
        '/' +
        this.$store.state.lang +
        this.$store.state.routes.govOption;
      let result = await this.$axios.get(route, {
        headers: {
          'X-Line-Biz-Session': localStorage.getItem(
            this.$store.state.storageKeys.token
          )
        }
      });
      this.infos = result.data;
    },
    checkActive() {
      if (this.hasSent) this.checkPopupAlert();
      this.alert.content = checkPopupAlert(
        this.params.content.length > this.contentLimit,
        this.alert.content
      );
      if (this.type === 'add' && this.isTWSE) {
          this.params.isRss = false;
          this.temp.rssTitle = '';
      }
      if (
        this.params.content &&
        this.params.content.length <= this.contentLimit &&
        this.params.url &&
        this.params.govOptionId &&
        this.params.title
        ) {
          this.isActive = !(this.params.isRss && !this.temp.rssTitle)
        }
      else this.isActive = false;
    },
    selectDropdown(event) {
      this.params.govOptionId = event.id;
      this.govName = event.name;
      this.checkActive();
    },
    closePopup() {
      this.hasSent = false;
      unlockBody();
      this.$emit('closePopup');
    },
    async send() {
      this.addRssParams()
      if (!this.isActive || this.isProcessing) return;
      this.isProcessing = true;
      this.hasSent = true;
      if (!this.checkPopupAlert()) return;
      let route;
      if (this.type === 'edit')
        route =
          this.$store.state.URLs.apiPartner +
          '/govAnnounces/' +
          this.govAnnounceInfo.id;
      else route = this.$store.state.URLs.apiPartner + '/govAnnounces';
      const data = new FormData();
      data.append('url', this.params.url);
      data.append('title', this.params.title);
      data.append('isRss', this.params.isRss);
      data.append('rssTitle', this.params.rssTitle);
      data.append('content', this.params.content);
      data.append('language', this.params.language);
      data.append('thumbnail', this.params.thumbnail);
      data.append('thumbnail2', this.params.thumbnail2);
      data.append('thumbnailUrl', this.params.thumbnailUrl);
      data.append('thumbnailTitle2', this.params.thumbnailTitle2);
      data.append('thumbnailUrl2', this.params.thumbnailUrl2);
      data.append('thumbnailTitle', this.params.thumbnailTitle);
      data.append('govOptionId', this.params.govOptionId);
      data.append('g-recaptcha-response', this.recaptchaResponse);
      this.$axios
        .post(route, data, {
          headers: {
            'X-Line-Biz-Session': localStorage.getItem(
              this.$store.state.storageKeys.token
            ),
            'Content-Type': 'multipart/form-data'
          }
        })
        .then(() => {
          this.isProcessing = false;
          this.closePopup();
          window.location.reload();
          this.$emit('isSuccess');
        })
        .catch(() => {
          this.isProcessing = false;
          this.closePopup();
          this.$emit('isError');
        });
    },
    checkPopupAlert() {
      this.alert.web = checkPopupAlert(
        !isValidURL(this.params.url),
        this.alert.web
      );
      if (!isValidURL(this.params.url)) return false;
      else return true;
    },
    uploadImg(event) {
      this.params.thumbnail = event;
      this.checkActive();
    },
    uploadImg2(event) {
      this.params.thumbnail2 = event;
      this.checkActive();
    },
    updateThumbTitle(val) {
      this.params.thumbnailTitle = val;
    },
    updateThumbTitle2(val) {
      this.params.thumbnailTitle2 = val;
    },
    _toggleRSS() {
      this.params.isRss = !this.params.isRss;
      this.checkActive()
    },
    addRssParams() {
      this.params.rssTitle = this.params.isRss ? this.temp.rssTitle : '';
    }
  }
};
</script>
<style scoped src="../../assets/koromo_min.css"></style>
<style scoped src="./popup_add_edit_comment_gov.vue.css"></style>
